module.exports = __webpack_public_path__ + "static/media/ic-collapse-arrows.566f8715.svg";